import React from 'react';
import { components } from 'react-select';
import { Reference } from 'react-popper';

var Control = function Control(props) {
  return /*#__PURE__*/React.createElement(Reference, null, function (_ref) {
    var ref = _ref.ref;
    return /*#__PURE__*/React.createElement("div", {
      ref: ref
    }, /*#__PURE__*/React.createElement(components.Control, props));
  });
};

export default Control;
//# sourceMappingURL=Control.js.map
